import { render, staticRenderFns } from "./changeGoodBadTypeBatch.vue?vue&type=template&id=5cc7cebb&"
import script from "./changeGoodBadTypeBatch.vue?vue&type=script&lang=js&"
export * from "./changeGoodBadTypeBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports